// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  baseLabel: "GrowthBars__baseLabel",
  chart: "GrowthBars__chart",
  value: "GrowthBars__value",
  year: "GrowthBars__year",
};
